import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Component, Inject, Input, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { BookService } from 'src/app/api/book.service';



@Component({
  selector: 'app-instruction',
  templateUrl: './instruction.component.html',
  styleUrls: ['./instruction.component.scss']
})
export class InstructionComponent  {

  constructor(private snackBar: MatSnackBar, private BookService: BookService, private sanitizer: DomSanitizer, public dialog: MatDialog,
    public dialogRef: MatDialogRef<InstructionComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

    next: boolean = false;
    IsLoad: boolean = false;

   
  sanitizeImageUrl(imageUrl: any): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(imageUrl);
  }


  onClickSuivant(){

    this.next = true
    
  }

  onClickStart(){
    this.IsLoad = true
  this.BookService.remoteStart(this.data.book.id).subscribe(
    data => {
    console.log(data)
    if(data.success === true){ 
      this.openSnackBarDone(data.message)
      this.IsLoad = false
      this.dialogRef.close(true);

    }
    else{
      this.openSnackBarError(data.data.support_phone)
      this.IsLoad = false
      this.dialogRef.close(true);
    }
    
    // this.IsWait = false;
    // this.members = data.data.sort((a,b) => a.index - b.index)
    },
    err => {
      console.log(err)
      this.openSnackBarError(err.message)
      this.IsLoad = false
      this.dialogRef.close(true);
    });
  
  }


  openSnackBarDone(message: string) {
    this.snackBar.open(message, "X", {
      panelClass: ['sucess-snackbar'],
      duration: 20000,
    });
  }


  openSnackBarError(message: string) {
    this.snackBar.open(message, "X", {
      panelClass: ['error-snackbar'],
      duration: 20000,
    });
  }
  


}
